import script from "./delete-election-modal.vue?vue&type=script&lang=js"
export * from "./delete-election-modal.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__